import { render, staticRenderFns } from "./AddGoodsImageModal.vue?vue&type=template&id=a1c9aab2&scoped=true"
import script from "./AddGoodsImageModal.vue?vue&type=script&lang=js"
export * from "./AddGoodsImageModal.vue?vue&type=script&lang=js"
import style0 from "./AddGoodsImageModal.vue?vue&type=style&index=0&id=a1c9aab2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c9aab2",
  null
  
)

export default component.exports